<template>
  <v-dialog
    v-model="localDialog"
    width="50%"
    @update:modelValue="updateDialog"
    persistent
  >
    <v-card>
      <v-card-title class="text-h6">
        <span>Disburse Claim Money</span>
      </v-card-title>

      <v-divider></v-divider>
      <v-card-text class="pa-4">

        <v-form ref="disburseForm" @submit.prevent="submit">
          <v-row>
            <v-col cols="12">
              <v-alert type="info" density="compact">
                <div><strong>Code:</strong> {{ claimData?.code }}</div>
                <div><strong>Due Amount:</strong> {{ formatCurrency(claimData?.due_amount || 0) }}</div>
              </v-alert>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6" class="pa-0 pl-3 pr-2">
              <v-date-input
                input-format="dd/mm/yyyy"
                v-model="disbursement_date.value.value"
                label="Disbursement Date"
                variant="outlined"
                density="compact"
                prepend-icon=""
                class="my-0"
                prepend-inner-icon="mdi-calendar"
                :error-messages="disbursement_date.errorMessage.value"
              >
                <template #label>
                    Disbursement Date <span class="text-red-accent-4">*</span>
                </template>
              </v-date-input>
            </v-col>
  
            <v-col cols="12" md="6" class="pa-0 pl-3 pr-2">
              <v-text-field
                v-model="paid_amount.value.value"
                label="Paid Amount *"
                variant="outlined"
                density="compact"
                type="number"
                min="0.01"
                step="0.01"
                prepend-inner-icon="mdi-currency-usd"
                :error-messages="paid_amount.errorMessage.value"
                :max="100"
              >
                <template #label>
                  Paid Amount <span class="text-red-accent-4">*</span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6" class="pa-0 pl-3 pr-2">
              <v-select
                v-model="payment_method.value.value"
                :items="paymentMethods"
                item-title="text"
                item-value="value"
                label="Payment Method *"
                variant="outlined"
                density="compact"
                prepend-inner-icon="mdi-cash-multiple"
                :error-messages="payment_method.errorMessage.value"
                @update:model-value="onPaymentMethodChange"
                clearable
              
                  :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                <template #label>
                  Payment Method <span class="text-red-accent-4">*</span>
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" md="6" class="pa-0 pl-3 pr-2">
              <v-autocomplete
                v-model="payment_acc_account_head_id.value.value"
                :items="getPaymentAccountHeadList"
                :item-title="(item) => item.name || 'Select'"
                item-value="id"
                label="Payment Account Head *"
                variant="outlined"
                density="compact"
                prepend-inner-icon="mdi-bank"
                :error-messages="payment_acc_account_head_id.errorMessage.value"
                :loading="paymentAccountHeadLoading"
                clearable
              
                  :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                <template #label>
                  Payment Account Head
                  
                  <span v-if="payment_method.value.value === 'BANK' || payment_method.value.value === 'CASH'" class="text-red-accent-4">*</span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <template v-if="payment_method.value.value === 'BANK'">
            <v-row>
              <v-col cols="12" md="6" class="pa-0 pl-3 pr-2">
                <v-text-field
                  v-model="cheque_no.value.value"
                  label="Cheque No *"
                  variant="outlined"
                  density="compact"
                  prepend-inner-icon="mdi-checkbook"
                  :error-messages="cheque_no.errorMessage.value"
                  maxlength="30"
                >
                  <template #label>
                    Cheque No <span class="text-red-accent-4">*</span>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" md="6" class="pa-0 pl-3 pr-2">
                <v-date-input
                  input-format="dd/mm/yyyy"
                  v-model="cheque_date.value.value"
                  label="Cheque Date *"
                  variant="outlined"
                  density="compact"
                  prepend-icon=""
                  prepend-inner-icon="mdi-calendar"
                  :error-messages="cheque_date.errorMessage.value"
                >
                  <template #label>
                    Cheque Date <span class="text-red-accent-4">*</span>
                  </template>
                </v-date-input>
              </v-col>
            </v-row>
          </template>

          <template v-if="payment_method.value.value === 'MOBILE_BANKING'">
            <v-row>  
              <v-col cols="12" md="6" class="pa-0 pl-3 pr-2">
                <v-autocomplete
                  v-model="mobileProvider.value.value"
                  :items="mobileProviders"
                  item-title="label"
                  item-value="value"
                  label="Provider *"
                  variant="outlined"
                  density="compact"
                  prepend-inner-icon="mdi-cellphone"
                  :error-messages="mobileProvider.errorMessage.value"
                  clearable
                
                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                  <template #label>
                    Provider <span class="text-red-accent-4">*</span>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="6" class="pa-0 pl-3 pr-2">
                <v-text-field
                  v-model="transactionId.value.value"
                  label="Transaction ID *"
                  variant="outlined"
                  density="compact"
                  prepend-inner-icon="mdi-identifier"
                  :error-messages="transactionId.errorMessage.value"
                  maxlength="50"
                >
                  <template #label>
                    Transaction ID <span class="text-red-accent-4">*</span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </template>

          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="remarks.value.value"
                label="Remarks"
                variant="outlined"
                density="compact"
                rows="3"
                :error-messages="remarks.errorMessage.value"
              ></v-textarea>
            </v-col>
          </v-row>

        </v-form>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="pa-4">
        <v-btn
          class="bg-red"
          variant="flat"
          type="reset"
          @click="closeDialog"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          variant="flat"
          @click="submit"
        >
          Disburse
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";

export default {
  name: "HrmClaimDisbursement",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object
    },
  },
  data() {
    return {
      localDialog: this.dialog,
      errorMessages: "",
      loading: false,
      claimData: {},
      paymentMethods: [
        { text: "Cash", value: "CASH" },
        { text: "Bank", value: "BANK" },
        { text: "Mobile Banking", value: "MOBILE_BANKING" },
      ],
      mobileProviders: [
        { label: "Bkash", value: "bkash" },
        { label: "Nagad", value: "nagad" },
        { label: "Rocket", value: "rocket" },
      ],

      paymentAccountHeadLoading: false
    };
  },
  computed: {
    getPaymentAccountHeadList() {
      return this.$store.getters.getPaymentAccountHeadList;
    },
  },
  watch: {
    dialog(val) {
      this.localDialog = val;
    },
    localDialog(val) {
      this.$emit("update:dialog", val);
    },
    data: {
      handler(newData) {
        this.claimData = newData;
        this.resetForm({ errors: {}, touched: {} });
        this.claim_id.setValue(newData.id || null, false);
        this.disbursement_date.setValue(new Date() || null, false);
        this.paid_amount.setValue(newData.due_amount || null, false);
      },
    },
  },
  created() {
    
  },
  methods: {
    formattedDate,
    onPaymentMethodChange() {
      // if (this.payment_method.value.value) {
        this.paymentAccountHeadLoading = true;
        this.$store.dispatch("getPaymentAccountHeadList", { 
            type: this.payment_method.value.value 
        }).then(() => {
          this.paymentAccountHeadLoading = false;
        });

        this.payment_acc_account_head_id.value.value = null;
      // }
    },

    formatCurrency(value) {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value || 0);
    },

    updateDialog(val) {
      this.$emit("update:dialog", val);
    },

    closeDialog() {
      this.resetForm()
      this.$emit("update:dialog", false);
    },
  },

  setup(props, { emit }) { 

    const store = useStore();

    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
      disbursement_date: yup.date().required().label("Disbursement Date"),
      paid_amount: yup.number().positive().min(0.01).required().label("Paid Amount"),
      payment_method: yup.string().required().label("Payment Method"),
      payment_acc_account_head_id: yup.number().positive().integer().nullable().when("payment_method", {
        is: (value) => ["BANK", "CASH"].includes(value),
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable()
      }).label("Payment Account Head"),
      cheque_no: yup.string().nullable().max(30).when("payment_method", {
        is: "BANK",
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable()
      }).label("Cheque no."),
      cheque_date: yup.date().nullable().when("payment_method", {
        is: "BANK",
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable()
      }).label("Cheque Date"),
      mobileProvider: yup.string().nullable().when("payment_method", {
        is: "MOBILE_BANKING",
        then: (schema) => schema.required("Provider is required"),
        otherwise: (schema) => schema.nullable(),
      }),
      transactionId: yup.string().nullable().when("payment_method", {
        is: "MOBILE_BANKING",
        then: (schema) => schema.required("Transaction ID is required"),
        otherwise: (schema) => schema.nullable(),
      }),
      remarks: yup.string().nullable().max(255).label("Remarks"),
    })
    });

    const claim_id = useField("claim_id");
    const disbursement_date = useField("disbursement_date");
    const paid_amount = useField("paid_amount");
    const payment_method = useField("payment_method");
    const payment_acc_account_head_id = useField("payment_acc_account_head_id");
    const cheque_no = useField("cheque_no");
    const cheque_date = useField("cheque_date");
    const mobileProvider = useField("mobileProvider");
    const transactionId = useField("transactionId");
    const remarks = useField("remarks");

    const submit = handleSubmit((values) => {

      const disbursementData = {
        payment_method: payment_method.value.value,
        payment_acc_account_head_id: payment_acc_account_head_id.value.value,
        disbursement_date: formattedDate(disbursement_date.value.value),
        paid_amount: paid_amount.value.value,
        remarks: remarks.value.value,
      };
      
      if (values.payment_method === "BANK") {
        disbursementData.cheque_date = formattedDate(cheque_date.value.value);
        disbursementData.cheque_no = cheque_no.value.value;
      }
      
      if (values.payment_method === "MOBILE_BANKING") {
        disbursementData.mobileProvider = mobileProvider.value.value;
        disbursementData.transactionId = transactionId.value.value;
      }

      console.log(disbursementData)
      
      store
        .dispatch("disburseClaim", {
          data: disbursementData,
          id: claim_id.value.value,
        })
        .then((response) => {
          toast.success(response?.data?.message || "Money requisition disbursed successfully");
          store.dispatch("getClaimList");
          emit("update:dialog", false)
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || "Failed to disburse money requisition");
        })
      })

    return {
      submit,
      resetForm,
      claim_id,
      disbursement_date,
      paid_amount,
      payment_method,
      payment_acc_account_head_id,
      cheque_no,
      cheque_date,
      mobileProvider,
      transactionId,
      remarks,
    };
  },
  mounted() {},
};
</script>
